




















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class UNumericField extends Vue {
  @Prop({ required: false, default: 1 })
  public step!: number;

  @Prop({ required: false, default: "" })
  public value!: number;

  @Prop({ required: false, default: "" })
  public label!: string;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  @Prop({ required: false, default: true })
  public dynamicSize!: boolean;

  @Prop({ required: false, default: 0 })
  public min!: number;

  @Prop({ required: false, default: Infinity })
  public max!: number;

  public intervalRef!: any;
  public intervalTime!: any;
  public interval = 150;

  public get numericValue() {
    return +this.value;
  }

  public set numericValue(value) {
    this.$emit("input", +value);
  }

  public get inputWidth() {
    if (!this.dynamicSize) {
      return null;
    }

    let length = this.value.toString().length;
    if (!length) {
      length++;
    }

    return `${length * 9 + 61}px`;
  }

  public increment() {
    const incrementedValue = this.closestNumber(this.numericValue, true);
    if (incrementedValue > this.max) {
      return;
    }
    this.numericValue = incrementedValue;
  }

  public closestNumber(n, inc) {
    const i = inc ? 1 : -1;
    if ((n + i) % this.step === 0) {
      return n + i;
    }

    const q = Math.floor(n / this.step);

    if (inc) {
      return this.step * (q + (!q ? 0 : 1));
    }

    return this.step * (q - (q === 1 ? 0 : 1));
  }

  public decrement() {
    const decrementedValue = this.closestNumber(this.numericValue, false);
    if (decrementedValue < this.min) {
      return;
    }
    this.numericValue = decrementedValue;
  }

  public onControlClick(event, inc) {
    // IE 11 -> filter click event
    if (event.detail !== 0 || event.type === "click") return;
    if (inc) this.increment();
    else this.decrement();
  }
  public onStartLongPress(event, inc) {
    if (event.button !== 0 && event.type !== "touchstart") return;
    this.intervalTime = new Date();
    clearInterval(this.intervalRef);
    this.intervalRef = setInterval(() => {
      if (inc) this.increment();
      else this.decrement();
    }, this.interval);
  }
  public onStopLongPress(inc) {
    if (!this.intervalRef) return;
    const d: any = new Date();
    if (d - this.intervalTime < this.interval) {
      if (inc) this.increment();
      else this.decrement();
    }
    clearInterval(this.intervalRef);
    this.intervalRef = null;
  }
}
